import React from 'react';
import classNames from 'classnames';

export default function TextLink({
    component,
    children,
    onClick,
    to,
    target,
    color,
    center,
    className = ""
}) {

    
    const Component = component || "div";
    
    let classes = typeof className === "string" ? className.split(" ").reduce((acc, item) => {
        acc[item] = true
        return acc
    }, {}) : className;
        
    const Classes = classNames({
        "hover:text-dark cursor-pointer": true,
        [`text-${color}`]: color,
        "text-primary": !color,
        "text-center": center,
        ...classes
    })

    return (
        <Component
            className={Classes}
            to={to}
            onClick={onClick ? onClick : undefined}
            href={component === "a" ? to : undefined}
            target={target || '_self'}
        >   
            {children}
        </Component>
    )
}
